import { NewsItem } from '../../core/models/types';

export type AwardTitlePart =
  | { kind: 'html'; html: string }
  | { kind: 'player'; text: string; playerDefinitionId: string };

const categories = ['GOALKEEPER', 'DEFENDER', 'MIDFIELDER', 'FORWARD', 'GLOBAL'];
const escapeHtml = (text: string) => text.replace(/&/g, '&amp;').replace(/</g, '&lt;')
  .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');

/** Replace only ranked player names in the published template, preserving its HTML. */
export function newsAwardTitle(item: NewsItem): AwardTitlePart[] | null {
  const awards = item.facts?.['result']?.awards;
  const html = item.titleHtml;
  if (!['MATCHDAY_AWARDS', 'private.economy.awards-settled.v1'].includes(item.type) || item.templateVersion !== 1 || !html || !Array.isArray(awards)) return null;
  const parts: AwardTitlePart[] = [];
  let cursor = 0;
  let searchFrom = 0;
  for (const category of categories) {
    for (const award of awards.filter(a => a?.category === category)) {
      if (typeof award.playerName !== 'string' || !Number.isInteger(award.rank)) return null;
      const nameHtml = `<strong>${escapeHtml(award.playerName)}</strong>`;
      const prefix = `${award.rank}. `;
      const at = html.indexOf(prefix + nameHtml + ' (', searchFrom);
      // Custom or incompatible historical templates keep their original rendering.
      if (at < 0) return null;
      const start = at + prefix.length;
      searchFrom = start + nameHtml.length;
      if (typeof award.playerDefinitionId !== 'string' || !award.playerDefinitionId.trim()) continue;
      parts.push({ kind: 'html', html: html.slice(cursor, start) },
        { kind: 'player', text: award.playerName, playerDefinitionId: award.playerDefinitionId });
      cursor = searchFrom;
    }
  }
  if (!parts.length) return [{ kind: 'html', html }];
  parts.push({ kind: 'html', html: html.slice(cursor) });
  return parts;
}
